import i18next, { type TFunction } from 'i18next'
import type { AppNamespaces } from 'src/i18n/i18n'

const namespaceMap = {
	tApiError: 'apiError',
	tArchiveInvoices: 'archiveInvoices',
	tBanking: 'banking',
	tCompanyTemplate: 'companyTemplate',
	tDashboard: 'dashboard',
	tDeleteFreelancer: 'DeleteFreelancer',
	tErrors: 'errors',
	tExportInvoices: 'exportInvoices',
	tInvoices: 'invoices',
	tPayments: 'payments',
	tPrepareInvoices: 'prepareInvoices',
	tProjectChildren: 'projectChildren',
	tProjectlist: 'projectlist',
	tProposals: 'proposals',
	tPurchaseorders: 'purchaseorders',
	tPurchases: 'purchases',
	tQuoteGrid: 'quoteGrid',
	tQuoteGridPage1: 'QuoteGridPage1',
	tQuotelist: 'quotelist',
	tQuoteSummaryModal: 'QuoteSummaryModal',
	tRecapQuoteGrid: 'RecapQuoteGrid',
	tRecapQuoteHeader: 'RecapQuoteHeader',
	tReviewInvoices: 'reviewInvoices',
	tSuppliers: 'suppliers',
	tTeamsettings: 'teamsettings',
} as const satisfies Record<string, AppNamespaces>

type TranslationKey = keyof typeof namespaceMap

type GlobalTranslationRegistry = Record<TranslationKey, TFunction>

type NamespaceEntry = [TranslationKey, (typeof namespaceMap)[TranslationKey]]

const assignTranslations = () => {
	;(Object.entries(namespaceMap) as NamespaceEntry[]).forEach(
		([translationKey, namespace]) => {
			;(globalThis as unknown as GlobalTranslationRegistry)[
				translationKey
			] = i18next.getFixedT(null, namespace)
		}
	)
}

assignTranslations()

i18next.on('languageChanged', assignTranslations)
